'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _TagOutlined = _interopRequireDefault(require('./lib/icons/TagOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _TagOutlined;
  exports.default = _default;
  module.exports = _default;